import './oiSearchBar.css';
import React from 'react';
import FaSearchIcon from 'react-icons/lib/fa/search';

const oiSearchBar = (props) => {
    let icon = '';
    let text = '';
    let style = '';

    if (props.isFull) {
        icon = '';
        text = 'Digite aqui sua pesquisa';
        style = 'search-full-is-open';
    }
    else {
        style = '';
        text = 'Busca';
        icon = (
            <FaSearchIcon
                id="oi-search-bar-icon"
                onClick={props.clickEvent}
            />
        );
    }

    return (
        <div id="oi-search-bar" className={style}>
            <form onSubmit={props.clickEvent}>
                {icon}

                <input
                    type="text"
                    autoFocus={false}
                    placeholder={text}
                    id="oi-search-bar-input"
                    onClick={props.layerEvent}
                    onChange={props.changeEvent}
                />
            </form>
        </div>
    );
};

export default oiSearchBar;


// WEBPACK FOOTER //
// ./src/components/oiSearchBar/oiSearchBar.js